import { TemplatePage } from './types';

const educationPage: TemplatePage = {
  header: {
    color: '#C0E1E6',
    icon: 'images/video-templates/education.jpg',
    title: 'Education Video Templates Collection',
    title_meta: '100+ Free and Customizable Education Video Templates',
    description_meta:
      'Create engaging educational videos with Wave.video’s 100+ customizable education video templates.',
    description:
      'Create engaging educational videos with these 100+ customizable education video templates. Get the most out of ' +
      'videos that are both informative and entertaining.'
  },
  footer: {
    category: 'Education',
    description:
      'Wave.video’s impressive collection of eye-catching education video templates helps to make compelling videos for ' +
      'any purpose in minutes. All the templates are easy and free to customize to suit your brand and message.'
  },
  content: [
    {
      type: 'templates',
      title: 'Education Video Templates',
      search: { category: '/Industries/Education' }
    },
    {
      type: 'stocks',
      title: 'education',
      search: { name: 'education' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default educationPage;
